export async function requestUploadImage(file: File) {
  const formData = new FormData()
  formData.append('file', file)
  return http
    .post<UploadImageRes>('/v1/media/upload_image', formData)
    .catch((error) => {
      return {
        code: -1,
        msg: `图片上传失败，请重试, ${error}`,
        data: { file: { file_path: '' } }
      }
    })
}
